export interface ISection {
    saveAndClose: { (callback: { (res: boolean): any }): any }
}

export interface TableSectionProps<D> {
    ref: { (r: ISection): any }
    id: string
    model: D
    tableModel: D[]
    onChange: { (model: D, close?: boolean): any }
    onRemove: { (): any }
    onClose: { (): any }
    importing: boolean
    preview: boolean
}
